// extracted by mini-css-extract-plugin
module.exports = {"top-6":"alert_top-6__2d6Ts"};